import cx from "classnames"

import type { LoadingModesType } from "./types"

import styles from "./index.module.css"
import { LOADING_MODES } from "./types"

type LoadingBarProps = {
  children?: React.ReactNode
  icon?: React.ReactNode
  isFullScreen?: boolean
  mode?: LoadingModesType
}

export const LoadingBar = ({ icon, children, isFullScreen, mode = "auto" }: LoadingBarProps): React.JSX.Element => {
  const loadingBarClassNames = cx(styles.loader, LOADING_MODES[mode], {
    [styles.fullScreen]: isFullScreen,
  })

  return (
    <div className={loadingBarClassNames}>
      {icon && <div className={styles.iconContainer}>{icon}</div>}
      <div className={styles.loadingBar}>
        <div className={styles.loadingProgress}></div>
      </div>
      {children && <span className={styles.text}>{children}</span>}
    </div>
  )
}
